import { z } from "zod"

import type { SyncEntity } from "./sync.ts"

/**
 * Product features an organisation can hold (receipts plan 1.1). The single source for feature
 * ids and for which feature each sync entity belongs to.
 *
 * `me.entitlements.features` is a lenient `string[]` on the wire so a newer server can add a
 * feature without breaking older clients; use `featureSchema` only where a known id is required.
 * `receipt_inbox` is the receipt forwarding address (T1035), Pro only (decisions.md section 3).
 */
export const FEATURES = ["logbook", "receipts", "invoicing", "teams", "receipt_inbox"] as const
export const featureSchema = z.enum(FEATURES)
export type Feature = z.infer<typeof featureSchema>

export const SYNC_ENTITY_FEATURE: Record<SyncEntity, Feature> = {
  vehicles: "logbook",
  trips: "logbook",
  trip_tracks: "logbook",
  odometer_readings: "logbook",
  documents: "receipts",
  extractions: "receipts",
  expenses: "receipts",
  logbook_periods: "logbook",
  customers: "invoicing",
  invoices: "invoicing",
  payments: "invoicing",
  payment_receipts: "invoicing",
  organisation_branding: "invoicing",
  seller_profiles: "invoicing",
}
